import React, { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const { isAuthenticated, loading, login } = useAuth();
  const location = useLocation();
  const [error, setError] = useState(null);
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const from = location.state?.from?.pathname || '/';

  if (loading) {
    return null;
  }

  if (isAuthenticated) {
    return <Navigate to={from} replace />;
  }

  const handleKeycloakLogin = async () => {
    try {
      setError(null);
      setIsLoggingIn(true);
      await login();
    } catch (err) {
      setError(err?.message || 'Failed to initiate Keycloak login. Please verify server configuration.');
      setIsLoggingIn(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'radial-gradient(ellipse at top, #1E293B 0%, #0F172A 50%, #090D16 100%)',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      padding: '24px',
      boxSizing: 'border-box',
    }}>
      <div style={{
        width: '100%',
        maxWidth: '440px',
        background: 'rgba(30, 41, 59, 0.7)',
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '16px',
        padding: '40px 32px',
        boxShadow: '0 20px 50px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
        color: '#F8FAFC',
        textAlign: 'center',
      }}>
        {/* Header / Brand */}
        <div style={{
          width: '56px',
          height: '56px',
          margin: '0 auto 20px',
          background: 'linear-gradient(135deg, #3B82F6 0%, #1D4ED8 100%)',
          borderRadius: '14px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 8px 20px rgba(59, 130, 246, 0.3)',
        }}>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </div>

        <h1 style={{ fontSize: '24px', fontWeight: '700', margin: '0 0 8px', letterSpacing: '-0.5px', color: '#F8FAFC' }}>
          NS Sales Bot
        </h1>
        <p style={{ fontSize: '14px', color: '#94A3B8', margin: '0 0 28px', lineHeight: '1.5' }}>
          Internal Operator Console & Session Management
        </p>

        {error && (
          <div style={{
            background: 'rgba(239, 68, 68, 0.15)',
            border: '1px solid rgba(239, 68, 68, 0.3)',
            borderRadius: '10px',
            padding: '12px 16px',
            marginBottom: '24px',
            fontSize: '13px',
            color: '#FCA5A5',
            textAlign: 'left',
            lineHeight: '1.4',
          }}>
            {error}
          </div>
        )}

        {/* Action button */}
        <button
          onClick={handleKeycloakLogin}
          disabled={isLoggingIn}
          style={{
            width: '100%',
            padding: '14px 20px',
            fontSize: '15px',
            fontWeight: '600',
            color: '#FFFFFF',
            background: isLoggingIn
              ? '#334155'
              : 'linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%)',
            border: 'none',
            borderRadius: '10px',
            cursor: isLoggingIn ? 'not-allowed' : 'pointer',
            boxShadow: isLoggingIn ? 'none' : '0 4px 14px rgba(37, 99, 235, 0.4)',
            transition: 'all 0.2s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
          }}
        >
          {isLoggingIn ? (
            <>
              <div style={{
                width: '18px',
                height: '18px',
                border: '2px solid rgba(255,255,255,0.3)',
                borderTopColor: '#FFF',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite'
              }} />
              Connecting to Keycloak...
            </>
          ) : (
            <>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
                <polyline points="10 17 15 12 10 7" />
                <line x1="15" y1="12" x2="3" y2="12" />
              </svg>
              Sign in
            </>
          )}
        </button>

        <p style={{ fontSize: '12px', color: '#64748B', marginTop: '24px', margin: '24px 0 0' }}>
          Strictly for authorized NS operators and administrators.
        </p>
      </div>
    </div>
  );
}
